const config = {
    apiBaseUrl: process.env.VUE_APP_OSIGU_API_BASE_URL,
    getTokenMaxAttempts: process.env.VUE_APP_GET_TOKEN_MAX_ATTEMPTS,
    getTokenAttemptDelayInSeconds: process.env.VUE_APP_GET_TOKEN_ATTEMPTS_DELAY_IN_SECONDS,
    clientId: process.env.VUE_APP_CLIENT_ID,
    clientSecret: process.env.VUE_APP_CLIENT_SECRET,
    intercomId: process.env.VUE_APP_INTERCOM_APP_ID,
    intercomKey: process.env.VUE_APP_INTERCOM_KEY,
    theme: process.env.VUE_APP_THEME,
    locale: process.env.VUE_APP_DEFAULT_LOCALE
  }
  
  export { config }
  